<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <div class="layout-sidebar" @click="onSidebarClick">
      <TokenTimer @tokenExpired="onTokenExpired" />
      <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
    </div>

    <Toast />
    <div class="layout-main-container">
      <div class="layout-main">
        <router-view />
      </div>
      <AppFooter />
    </div>

    <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" />
    <transition name="layout-mask">
      <div
        class="layout-mask p-component-overlay"
        v-if="mobileMenuActive"
      ></div>
    </transition>
  </div>
</template>

<script>
//COMPONENTS
import AppTopBar from "./components/menu/AppTopbar.vue";
import AppMenu from "./components/menu/AppMenu.vue";
import AppConfig from "./components/menu/AppConfig.vue";
import AppFooter from "./components/menu/AppFooter.vue";
import TokenTimer from "./components/menu/TokenTimer.vue";

export default {
  emits: ["change-theme"],
  data() {
    return {
      user: [],
      layoutMode: "static",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: [
        {
          label: "Principal",
          items: [
            {
              label: "Home",
              icon: "pi pi-fw pi-home",
              to: "/system",
            },
          ],
        },
        {
          label: "Solicitação",
          items: [
            {
              label: "Solicitação de Registros",
              icon: "pi pi-fw pi-plus",
              to: "/registrar-solicitacao",
              visible: () =>
                this.findPermission("ROLE_CDAS_REGISTRAR_SOLICITACAO") ||
                this.findPermission("R-CDAS101"),
            },
            {
              label: "Finalizar Solicitação",
              icon: "pi pi-fw pi-check",
              to: "/finalizar-solicitacao",
              visible: () =>
                this.findPermission("ROLE_CDAS_FINALIZAR_SOLICITACAO") ||
                this.findPermission("R-CDAS102"),
            },
            {
              label: "Consultar Solicitação",
              icon: "pi pi-fw pi-search",
              to: "/consultar-solicitacao",
              visible: () =>
                this.findPermission("ROLE_CDAS_CONSULTAR_SOLICITACAO") ||
                this.findPermission("R-CDAS103"),
            },
          ],
        },
        {
          label: "Administração",
          items: [
            {
              label: "Gerenciamento de Operadores",
              icon: "pi pi-fw pi-user",
              to: "/operadores",
              visible: () =>
                this.findPermission("ROLE_CDAS_GERENCIAR_OPERADORES") ||
                this.findPermission("R-CDAS104"),
            },
          ],
        },
      ],
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  mounted() {},
  created() {
    this.checkCookieSession();
  },
  methods: {
    checkCookieSession() {
      let cookieToken = this.getCookie("access_token");
      let cookieLocal = this.getCookie("local");
      //VERIFICA SE POSSUE TOKEN NO COOKIE DO NAVEGADOR
      if (cookieToken && cookieLocal) {
        this.$store.dispatch("setUserLogged");
        this.user = this.$store.getters.getUserLogged;

        return true;
      } else {
        alert("Usuário desconectado! Você precisa fazer login novamente");
        return false;
      }
    },
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        let [key, value] = cookie.split("=");
        if (key === name) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
    findPermission(p) {
      if (this.user.authorities) {
        let isPermited = this.user.authorities.filter((a) => a == p);
        return isPermited.length > 0;
      } else {
        return false;
      }
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;
      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
      }

      return true;
    },
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === false,
        },
      ];
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppMenu: AppMenu,
    AppConfig: AppConfig,
    AppFooter: AppFooter,
    TokenTimer: TokenTimer,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
